module.exports = __webpack_public_path__ + "img/Logo.7655f4e2.png";